import RidersBG from "@/assets/riders-bg.png";
import RidersLayoutPlaceholderImage from "@/assets/riders-layout-placeholder.png";
import PublicAutonomCarWorkshopImage from "@/assets/public_otonom_car_workshop.png";
import PublicSmartCityWorkshopImage from "@/assets/public_smart_city_workshop.png";
import { RidersTextIcon } from "@/components/shared/RidersTextIcon";
import { message } from "antd";
import React, { useEffect, useLayoutEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { PlayIcon } from "lucide-react";

export const NoTokenPage: React.FC<{ isTwa?: boolean }> = ({ isTwa }) => {
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);
  const [manualToken, setManualToken] = useState("");

  useLayoutEffect(() => {
    document.getElementById("boot-loading")?.remove();
  }, []);

  const handleOpenSite = () => {
    // tarayıcıda riders'ı aç
    window.electron?.ipcRenderer?.send(
      "open-external",
      "https://riders.ai/api/open-from-app"
    );
    // uygulamayı kapat
    window.electron?.quitApp?.();
  };

  const openTokenModal = useCallback(() => {
    setManualToken("");
  }, []);

  // Klavye kısayolu dinleme
  useEffect(() => {
    const handleKeydown = (e: KeyboardEvent) => {
      if (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === "m") {
        e.preventDefault();
        setShowPopup(true);
      }
    };

    window.addEventListener("keydown", handleKeydown, { capture: true });
    return () =>
      window.removeEventListener("keydown", handleKeydown, { capture: true });
  }, []);

  const handleSubmitToken = () => {
    const token = manualToken.trim();
    if (!token) {
      message.error("Lütfen geçerli bir token girin.");
      return;
    }

    // (1) Renderer -> Main: deep link hard redirect (opsiyonel ama faydalı)
    (window.electron?.ipcRenderer as any)?.send(
      "deep-link-hard-redirect",
      token
    );

    // (2) Router ile /v4/:token sayfasına geç.
    // Editor bileşenin bu rotada token'ı useParams ile alıp initUser akışını başlatıyor.
    navigate(`/v4/${token}`, { replace: true });
  };

  const handleTokenSubmit = () => {
    const token = manualToken.trim();
    if (!token) return;
    window.location.href = `/v4/${token}`;
  };

  const handleRedirectToPublicProject = (url: string) => {
    window.location.href = url;
  };

  return (
    <div
      className="w-full h-screen flex items-center justify-center bg-primary"
      style={{ backgroundImage: `url(${RidersBG})` }}
    >
      {!isTwa && (
        <div className="bg-background rounded-2xl shadow-xl flex flex-col items-center justify-between px-6 max-w-[500px] space-y-6 pt-10 pb-10">
          <RidersTextIcon height={50} />
          <p className="text-center text-gray-500">Riders’a Hoşgeldin!</p>
          <p className="text-center text-gray-500">
            Riders App’i kullanabilmek için tarayıcıdan derse giriş yapman
            lazım.
          </p>
          <img src={RidersLayoutPlaceholderImage} width={120} alt="" />
          <p className="text-center text-gray-500">
            Şimdi lütfen Riders’ı tarayıcıdan aç ve derslerine ulaş!
          </p>
          <button
            className="bg-primary rounded-full p-2 text-white px-6 hover:cursor-pointer hover:bg-primary/80 transition-colors"
            onClick={handleOpenSite}
          >
            Riders'a Git
          </button>
        </div>
      )}

      {isTwa && (
        <div className="bg-background rounded-2xl shadow-xl flex flex-col items-center justify-between px-6 max-w-[500px] space-y-6 pt-10 pb-10">
          <RidersTextIcon height={50} />
          <p className="text-center text-slate-500">Riders’a Hoşgeldin!</p>
          <p className="text-center text-slate-500">
            Atölyelerimizi kullan ve uygulayarak öğren
          </p>
          <div className="w-full flex items-center justify-center space-x-4 cursor-pointer">
            <div
              className="group w-36 h-48 bg-red-300 rounded-4xl relative overflow-hidden cursor-pointer"
              onClick={() =>
                handleRedirectToPublicProject(
                  "https://editor.riders.ai/v4/twa/city-autonomous"
                )
              }
            >
              {/* Gradient + text */}
              <div className="z-50 absolute text-white p-2 font-medium cursor-pointer">
                Otonom Araç Atölyesi
              </div>
              <div className="z-50 absolute opacity-60 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-primary rounded-full p-4 text-white">
                <PlayIcon />
              </div>
              <div className="z-40 absolute bg-gradient-to-b from-black to-transparent w-full h-full opacity-40 cursor-pointer"></div>

              {/* Resim */}
              <img
                src={PublicAutonomCarWorkshopImage}
                alt=""
                className="w-full cursor-pointer h-full object-cover transform transition-transform duration-500 ease-in-out group-hover:scale-120"
              />
            </div>
            <div
              className="group w-36 h-48 bg-red-300 rounded-4xl relative overflow-hidden cursor-pointer"
              onClick={() =>
                handleRedirectToPublicProject(
                  "https://editor.riders.ai/v4/twa/city-01"
                )
              }
            >
              {/* Gradient + text */}
              <div className="z-50 absolute text-white p-2 font-medium cursor-pointer">
                Akıllı Şehir Atölyesi
              </div>
              <div className="z-50 absolute opacity-60 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-primary rounded-full p-4 text-white">
                <PlayIcon />
              </div>
              <div className="z-40 absolute bg-gradient-to-b from-black to-transparent w-full h-full opacity-40 cursor-pointer"></div>

              {/* Resim */}
              <img
                src={PublicSmartCityWorkshopImage}
                alt=""
                className="w-full cursor-pointer h-full object-cover transform transition-transform duration-500 ease-in-out group-hover:scale-120"
              />
            </div>
          </div>

          <p className="text-center text-slate-500">
            Dilersen tarayıcıdan giriş yaparak Riders derslerini de uygulamadan
            açabilirsin.
          </p>
        </div>
      )}

      {showPopup && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[99999]">
          <div className="bg-white rounded-lg p-6 w-[400px] shadow-xl">
            <h2 className="text-lg font-semibold mb-4">Token ile Aç</h2>
            <input
              type="text"
              value={manualToken}
              onChange={(e) => setManualToken(e.target.value)}
              placeholder="Token giriniz"
              className="border border-gray-300 rounded px-3 py-2 w-full mb-4 focus:outline-none focus:ring focus:ring-primary"
            />
            <div className="flex justify-end space-x-2">
              <button
                onClick={() => setShowPopup(false)}
                className="px-4 py-2 rounded bg-gray-300 hover:bg-gray-400"
              >
                İptal
              </button>
              <button
                onClick={handleTokenSubmit}
                className="px-4 py-2 rounded bg-primary text-white hover:bg-primary/80"
              >
                Aç
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
